import type { IAnimation, IframeContactInputFields } from './types';

export enum VisualType {
  ANIMATION = 'animation',
  IMAGE = 'image',
}

export const ANIMATIONS: ReadonlyArray<IAnimation> = [
  {
    id: 'doodles',
    thumbnail: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/doodles_thumb_square.jpg',
    image: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/doodles.gif',
  },
  {
    id: 'paper-plane',
    thumbnail: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/paper-plane_thumb_square.jpg',
    image: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/paper-plane.gif',
  },
  {
    id: 'falling-envelopes',
    thumbnail: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/falling-envelopes_thumb_square.jpg',
    image: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/falling-envelopes.gif',
  },
  {
    id: 'mailbox',
    thumbnail: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/mailbox_thumb_square.jpg',
    image: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/mailbox.gif',
  },
  {
    id: 'hooray',
    thumbnail: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/hooray_thumb_square.jpg',
    image: 'https://joy-public-assets-bucket.s3.us-west-2.amazonaws.com/hooray.gif',
  },
];

export const iframeContactInitialValue: IframeContactInputFields = {
  firstName: '',
  lastName: '',
  envelopeNameOverride: '',
  phoneNumber: '',
  email: '',
  address1: '',
  address2: '',
  postalCode: '',
  city: '',
  region: '',
  country: 'United States',
  countryCode: 'US',
  validated: false,
  legacyAddressString: '',
};
